import { BASE_URL } from './inquiries';
import { fetchWithAuth } from './apiClient';

/**
 * 콘텐츠 카테고리 (cms.categories)
 *
 * 조회는 공개, 변경은 인증 필요 — 서버 content-categories.controller.ts 와 같은 규율.
 */

const asJson = async (res, fallbackMessage) => {
    const text = await res.text();

    if (!res.ok) {
        let message = fallbackMessage;
        try {
            const body = JSON.parse(text);
            if (body?.message) message = Array.isArray(body.message) ? body.message.join('\n') : body.message;
        } catch {
            // 본문이 JSON 이 아니면 기본 메시지를 쓴다
        }
        throw new Error(message);
    }

    // 성공인데 본문이 비어 있는 경우가 있다(서버가 undefined 를 반환하면 NestJS 가 빈 200 을 보낸다).
    // 그대로 res.json() 을 부르면 "Unexpected end of JSON input" 이라는, 원인을 전혀
    // 알 수 없는 오류가 사용자에게 보인다. 빈 객체로 넘기고 화면은 새로고침으로 복구한다.
    if (!text) return {};

    try {
        return JSON.parse(text);
    } catch {
        throw new Error('서버 응답을 읽지 못했습니다. 잠시 후 다시 시도해 주세요.');
    }
};

/** type: solution | product | case | note (생략 시 전체) */
export const getContentCategories = async (type) => {
    const query = type ? `?type=${encodeURIComponent(type)}` : '';
    const res = await fetch(`${BASE_URL}/api/content-categories${query}`);
    return asJson(res, '카테고리를 불러오지 못했습니다.');
};

export const createContentCategory = async (payload) => {
    const res = await fetchWithAuth(`${BASE_URL}/api/content-categories`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    });
    return asJson(res, '카테고리를 추가하지 못했습니다.');
};

export const updateContentCategory = async (id, payload) => {
    const res = await fetchWithAuth(`${BASE_URL}/api/content-categories/${id}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    });
    return asJson(res, '카테고리를 수정하지 못했습니다.');
};

/** 소속 콘텐츠는 지우지 않고 reassignTo 로 옮긴다. 생략하면 '기타'로 간다. */
export const deleteContentCategory = async (id, reassignTo) => {
    const query = reassignTo ? `?reassignTo=${reassignTo}` : '';
    const res = await fetchWithAuth(`${BASE_URL}/api/content-categories/${id}${query}`, {
        method: 'DELETE',
    });
    return asJson(res, '카테고리를 삭제하지 못했습니다.');
};

/** 화면에서 정렬한 최종 순서를 통째로 보낸다. */
export const reorderContentCategories = async (contentType, orderedIds) => {
    const res = await fetchWithAuth(`${BASE_URL}/api/content-categories/reorder`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ contentType, orderedIds }),
    });
    return asJson(res, '순서를 저장하지 못했습니다.');
};
